import "./AddonInformationComponent.css"
import "./AddonInformationGradients.css"
import {formatDate, gradientGetter} from "../../../utils";
import {Trans, useTranslation} from "react-i18next";
import {Button} from "@mui/material";
import React from "react";
import BillingContentComponent from "../components/BillingContentComponent";
import EligibleAddonsComponent from "./components/EligibleAddonsComponent";
import AccountsService from "../../../../../services/AccountsService";
import {useLoading} from "../../../../../context/LoadingContext";
import AddonComponent from "./components/AddonComponent";
import {useCms} from "../../../../../context/CmsContext";
import CmsHelper, {PickProgramPageHelper} from "../../../../Utilities/CmsHelpers";

const AddonInformationComponent = ({userData, addonEligible, updateUserData, setErrorPopup}) =>{
    const {t} = useTranslation();

    const { removeLoading, addLoading} = useLoading();
    const {pickProgramData} = useCms();
    const pickAddons = PickProgramPageHelper.getPickAddons(PickProgramPageHelper.getPrograms(pickProgramData, CmsHelper.DEFAULT))?.addons;
    const addonMapper = (addon, cmsTitle) => {
        switch (addon?.state) {
            case "final_bill": {
                const Status = ({className}) => (
                    <span className={className} style={{ color: "#FFBE0B" }}>
                        {t("account-addon-scheduled-cancel")}
                    </span>
                );
                const Information = () => (
                    <div className={"addonInformation-hasUnsubscribed"}>
                        <img src={"images/account/unsubscribeIcon.svg"} alt={"addon unsubscribe icon"}/>
                        <span>
                            <Trans i18nKey="account-addon-scheduled-cancel-message"
                                   values={{date: formatDate(addon?.current_period_ends_at)}}
                                   tOptions={{interpolation: {escapeValue: false}}}
                            />
                        </span>
                    </div>
                )
                const PrimaryCta = () => (
                    <>
                        <Button variant={"contained"}
                                color={"primary"}
                                href={addon.magic_link}
                                target="_blank">
                            <Trans i18nKey="accountAddonPrimaryCta"
                                   values={{addon: cmsTitle}}
                                   tOptions={{interpolation: {escapeValue: false}}}
                            />
                        </Button>
                    </>
                )
                const CancelSubscriptionCta = () => (
                    <></>
                )
                return {Status, Information, PrimaryCta, CancelSubscriptionCta};
            }
            default: {
                const Status = ({className}) => (
                    <span className={className} style={{color: "#35F153"}}>
                        {t("account-addon-active")}
                    </span>
                );
                const Information = () => (
                    <div className={"addonSubscriptionInformation-content-wrapper"}>
                        <BillingContentComponent label={t("accountProductNextBillingAmount")} type={"amount"}>
                            <>
                                {addon?.renewalPreview?.total_amount_due_in_cents / 100}€
                            </>
                        </BillingContentComponent>
                        <BillingContentComponent type={"date"} label={t("accountProductNextBillingDate")}>
                            <>
                                {formatDate(addon?.renewalPreview?.next_assessment_at)}
                            </>
                        </BillingContentComponent>
                    </div>
                )
                const PrimaryCta = () => (
                    <>
                        <Button variant={"contained"}
                                color={"primary"}
                                href={addon.magic_link}
                                target="_blank">
                            <Trans i18nKey="accountAddonPrimaryCta"
                                   values={{addon: cmsTitle}}
                                   tOptions={{interpolation: {escapeValue: false}}}
                            />
                        </Button>
                    </>
                )
                const CancelSubscriptionCta = () => (
                    <div className={"addonInformation-cancel-cta-wrapper"}>
                        <button className={"addonInformation-cancel-cta"}
                                onClick={(e)=>{
                                    e.preventDefault();
                                    addLoading("ADDONCANCELSUBSCRIPTION")
                                    AccountsService.unsubscribeSubscriptionAddon({
                                        pricePoint: addon.product.product_price_point_handle
                                    })
                                        .then(async (res) => {
                                            return await updateUserData()
                                        })
                                        .catch(error => {
                                            setErrorPopup()
                                            console.debug("An error occured while addon unsubscribing: ", error.message)
                                        })
                                        .finally(()=>{
                                            removeLoading("ADDONCANCELSUBSCRIPTION")
                                        })
                                }}>
                            <Trans i18nKey="accountCancelAddonSubscriptionCTA"
                                   values={{addon: cmsTitle}}
                                   tOptions={{interpolation: {escapeValue: false}}}
                            />
                        </button>
                    </div>
                )
                return {Status, Information, PrimaryCta, CancelSubscriptionCta};
            }
        }
    }
    return (<>
        <div className={`account-addonComponent ${gradientGetter(userData?.subscription?.product?.name)}`}>
            {!!userData?.subscription?.addons?.length ?
                <>
                    {userData.subscription.addons.map((addon, index) => {
                        const cmsData = PickProgramPageHelper.getAddon(pickAddons, addon?.product?.name)[0]
                        if(!cmsData) return <></>

                        const {Status, Information, PrimaryCta, CancelSubscriptionCta} = addonMapper(addon, cmsData?.title)
                        return <>
                            <AddonComponent key={index} addon={cmsData?.title} Status={Status} Information={Information} PrimaryCta={PrimaryCta} CancelSubscriptionCta={CancelSubscriptionCta}/>
                        </>
                    })}
                </> : <>
                    {!!addonEligible ?
                        <>
                            {addonEligible.map((addon, index) => {
                                return <EligibleAddonsComponent key={index} addon={addon}/>
                            })}
                        </> : <></>
                    }
                </>

            }
        </div>
    </>)
}

export default AddonInformationComponent;